import { Button } from "antd";
import { PlayCircleOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";

export default function Hero() {
  const navigate = useNavigate();
  
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <section className="hero-section">
      <div className="container">
        <div className="row align-items-center g-4 g-lg-5">
          <div className="col-12 col-lg-6 hero-copy">
            <p className="hero-eyebrow">
              We are Ampstek Global
            </p>
            <h1 className="hero-title">
              We
              <br />
              Empower<span className="hero-trademark"></span>
            </h1>
            <p className="hero-subheading">
            The future by<span className="highlight-ring">connecting</span>  you with high-performing{" "}
              <span className="highlight-underline">digital</span> talent that delivers measurable impact.
            </p>
            <div className="hero-cta">
              <Button
                type="primary"
                size="large"
                className="hero-btn hero-btn--primary"
                onClick={() => navigate("/blogs")}
              >
                Explore our solutions
              </Button>
              <Button
                size="large"
                icon={<PlayCircleOutlined />}
                className="hero-btn hero-btn--ghost"
                onClick={() => scrollToSection("continents")}
              >
                Find Ampstek near you
              </Button>
            </div>
          </div>
          <div className="col-12 col-lg-6 hero-visual">
            <img
              src="/images/emp4.gif"
              alt="Hand holding phone with Creating Futures display and Earth globe"
              className="hero-image"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
